<div class="dialog-content">
  @if (dialogData.title) {
    <h2 class="dialog-title">{{ dialogData.title }}</h2>
  }

  <p class="dialog-message" [innerHTML]="dialogData.message | safe: 'html'"></p>

  <div class="dialog-actions">
    <button type="button" class="community-button ghost" dataTest="btn-dialog-cancel" (click)="onCancel()">
      {{ dialogData.cancelButtonText || 'Cancel' }}
    </button>

    <button type="button" class="community-button primary with-line" dataTest="btn-dialog-confirm" (click)="onConfirm()">
      {{ dialogData.confirmButtonText || 'Confirm' }}
    </button>
  </div>
</div>
